import {
  DdqGpInvitation,
  DdqInvitationDirection,
  DdqInviteeRow,
  DdqLpInvitation,
} from '@core/models/ddq-invitation.model';

function joinPersonName(first?: string | null, last?: string | null): string {
  return [first, last].filter((p) => !!p && String(p).trim()).join(' ').trim();
}

export function mapGpInvitationToInviteeRow(inv: DdqGpInvitation): DdqInviteeRow {
  const companyName =
    inv.inviteCompanyName?.trim() ||
    inv.inviteeInvestorCompanyName?.trim() ||
    inv.inviterEmittentCompanyName?.trim() ||
    '—';

  return {
    uid: inv.uid,
    companyName,
    personName: joinPersonName(inv.inviteFirstName, inv.inviteLastName) || '—',
    personEmail: inv.inviteeEmail,
    invitedAt: inv.invitedAt,
    status: inv.status,
    inviteeUserId: inv.inviteeUser ?? null,
    direction: 'gp',
    inviterOrganizationName: inv.inviterEmittentCompanyName ?? null,
  };
}

export function mapLpInvitationToInviteeRow(inv: DdqLpInvitation): DdqInviteeRow {
  const companyName =
    inv.issuerName?.trim() ||
    inv.inviteeEmittentCompanyName?.trim() ||
    inv.fundName?.trim() ||
    inv.inviterInvestorCompanyName?.trim() ||
    '—';

  return {
    uid: inv.uid,
    companyName,
    personName: joinPersonName(inv.inviteFirstName, inv.inviteLastName) || '—',
    personEmail: inv.inviteeEmail,
    invitedAt: inv.invitedAt,
    status: inv.status,
    inviteeUserId: inv.inviteeUser ?? null,
    direction: 'lp',
    inviterOrganizationName: inv.inviterInvestorCompanyName ?? null,
  };
}

export function mapInvitationsToInviteeRows(
  direction: DdqInvitationDirection,
  rows: DdqGpInvitation[] | DdqLpInvitation[],
): DdqInviteeRow[] {
  if (direction === 'gp') {
    return (rows as DdqGpInvitation[]).map(mapGpInvitationToInviteeRow);
  }
  return (rows as DdqLpInvitation[]).map(mapLpInvitationToInviteeRow);
}
